
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToasterService } from 'angular2-toaster';
import { LoginService } from 'src/app/services/login.service';
import { ConfigService } from 'src/app/services/config.service';

@Component({
    selector: 'app-social-signin-select-mall',
  templateUrl: './social-signin-select-mall.component.html',
  styleUrls: ['./social-signin-select-mall.component.scss']
})
export class SocialSigninSelectMallComponent implements OnInit {
  searchText: any = [];
  filteredListOfMalls: any[] = [];
  selectedMallCode: any = null;
  mallList: any[] = [];
  disableSearch: boolean = false;
  countryCode: any = [];
  selectedCountryCode: any;
  url: string;
  constructor(private router: Router, private loginService: LoginService, private toasterService: ToasterService, public config: ConfigService) { }

  ngOnInit() {
    this.config.getLocalStorageData();
    this.getMalls();
    this.url = this.config.cdnURL + '/CDN/' + this.config._tid;
  }

  getMalls() {

    this.loginService.fetchMalls(this.constructor.name).subscribe(result => {
      console.log(this.disableSearch)
      if (result["message"].code == 0) {
        this.mallList = result["data"].Response;

        if (this.mallList.length == 1) {

          this.disableSearch = true;
          console.log(this.disableSearch)
          this.selectedMallCode = this.mallList[0].oko_Row_Code;
        } else {

          this.disableSearch = false;
          console.log(this.disableSearch)
        }
        this.filteredListOfMalls = this.mallList;

      } else if (result["message"].code == 1005) {
        this.toasterService.pop("error", result["message"].message)
      } else {
        this.toasterService.pop("error", result["message"].message)
      }
    })
  }

  onInput(e) {
    console.log(e)
    //let searchedGroup = [];
    if (this.searchText.length) {
      // this.initializeItems(search);
      if (this.searchText && this.searchText.trim() != '') {
        let searchedGroup = this.mallList.filter((item) => {
          return (item.oko_Row_Desc.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1);
        });
        if (searchedGroup.length > 0) {
          this.filteredListOfMalls = searchedGroup;
        }
        else {
          this.filteredListOfMalls = [];
        }
      }
    } else {
      this.filteredListOfMalls = this.mallList;
    }


    document.getElementById('input').addEventListener('input', (e) => {
      // console.log(e)
      // console.log(e["inputType"])

      if (e["inputType"] != "insertText" && e["inputType"] != "deleteContentBackward") {
        return this.filteredListOfMalls = this.mallList;
      }
    })

  }

  onMallChange(e) {
  console.log("Selected mall:", this.selectedMallCode);
}
  selectMall(item: any) {
    this.selectedMallCode = item.oko_Row_Code;
  }  

  signUpWthMall(e) {

    if (this.selectedMallCode != null && this.selectedMallCode != '') {
      this.loginService.socialsignUpWthMall(this.selectedMallCode, this.config.userDetails).subscribe(results => {
        if (results["message"].code == 200 || results["message"].code == 0 || results["message"].code == 1018) {

        } else {
          this.toasterService.pop("error", results["message"].message)
        }
      })

      let mobilePhone = this.config.userDetails["mobileNumber"];
      //  let countryCode =this.config.userDetails["countryCode"] ;
      let countryCode = this.config.userDetails["countryTeleCode"]
      if (countryCode == null && mobilePhone != null) {
        this.toasterService.pop("error", "Invalid Country code")
        return;
      }
      if (!countryCode.startsWith('+')) {
        countryCode = '+' + countryCode;
      }
      // Remove country code from mobilePhone if it exists
      if (mobilePhone.startsWith(countryCode)) {
        mobilePhone = mobilePhone.replace(countryCode, '');
      }
      console.log("Processed Mobile Phone:", mobilePhone);
      let userDetails = {
        "userId": this.config.userDetails.userId,
        "name": this.config.userDetails.userName,
        "email": this.config.userDetails.email,
        "phone": mobilePhone,
        "countryCode": this.config.userDetails.countryTeleCode.replace('+', ''),
        "redirectParam": this.config.redirectParam ? this.config.redirectParam : "",
        ...this.config.genderobj,
        ...this.config.dobobj
      }
      console.log(userDetails)
      //return;
      //set in userdetails config
      this.loginService.redirectURL(userDetails, this.constructor.name).subscribe(results => {
        if (results["message"].code == 200 || results["message"].code == 0) {
          let redirectURL = results['data'].data.url
          window.location.href = redirectURL
        } else if (results["message"].code == 888) {
          this.toasterService.pop('error', "Please login after some time!!");
        } else {
          this.toasterService.pop("error", results["message"].message)
        }
      });
    } else {
      this.toasterService.pop("error", "Please select Mall to Proceed!")
    }
  }


 

}
